import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import {useFormik} from "formik";
import _ from "lodash";

const FormModal = ({type, editObject, handleSubmit, showComplete, renderForm, width, completeLabel, saveAndCloseLabel, validationSchema, disabled}) => {
    const navigate = useNavigate();

    const onHide = () => {
        navigate(-1);
    }

    const formik = useFormik({
        initialValues: _.cloneDeep(editObject),
        validationSchema,
        onSubmit: (data) => {
            handleSubmit(data);
            onHide();
        }
    });

    const onSaveAndClose = () => {
        formik.handleSubmit();
    }

    const onSaveAndComplete = () => {
        formik.setFieldValue("completed", true);
        formik.handleSubmit();
    }

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    const renderFooter = () => {
        return (
            <>
            {!disabled &&
                <div>
                    <Button type="button" label="Cancel" icon="pi pi-times" onClick={() => onHide()} className="p-button-text" />
                    {handleSubmit && (<Button type="button" label={saveAndCloseLabel || "Save and Close"} icon="pi pi-check" onClick={() => onSaveAndClose()} autoFocus />)}
                    {showComplete && handleSubmit && (<Button type="button" label={completeLabel || `Complete ${type}`} icon="pi pi-check-square" onClick={() => onSaveAndComplete()} />)}
                </div>
            }
            </>
        );
    }

    return (
        <Dialog modal={true} header={`${editObject?.id && editObject?.id !== 'new' ? 'Edit' : 'New'} ${type}`} visible={true} style={{ width: width || '50vw', height: '80vh' }} footer={renderFooter()} onHide={() => onHide()}>
            {renderForm(formik, isFormFieldValid, getFormErrorMessage)}
        </Dialog>
    );
}

export default FormModal;
